import Vue from 'vue'
import VueScrollStop from 'vue-scroll-stop'

Vue.use(VueScrollStop);